import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectorRef  } from '@angular/core';
import { FormControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { RestService } from '@app/_services/rest.service';
import { from, Observable, throwError } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import {AccountService, AlertService } from '@app/index';
import { MsalService } from '@azure/msal-angular';
import { catchError, concatMap, first } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { groups } from '@app/_services/auth-config';
import { AppComponent } from '@app/app.component';
import { ClaimDetails } from '@app/_models/claimDetails';
import { OriginalStatusTypes } from '@app/_models/originalStatusTypes';
import { UserActionsLogDatum } from '@app/_models/userActionsLogDatum';
import { Employee } from '@app/_models/employee.model';
import { Note } from '@app/_models/note';
import { MatRadioChange } from '@angular/material/radio';


@Component({
  selector: 'app-make-safe',
  templateUrl: './make-safe.component.html',
  styleUrls: ['./make-safe.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MakeSafeComponent implements OnInit {
  public form!: UntypedFormGroup;
  errorMsg!: string;
  refNo!: number;
  employeeId:number=0;
  isAssessorOrEstimator:boolean=false;
  claim!:ClaimDetails;
  lastNameS!: string;
  loading = false;
  submitted = false;
  result!: string;
  @Input() max: any;
  newNote!:Note;
  buildingMakeSafeRequired!:boolean;
  restorationMakeSafeRequired!:boolean;
  isSignedWaiverReceived!:boolean;
  isChanged:boolean=false;
  //isHMAUser!:boolean; 
  //isHMAClaim!:boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private accountService: AccountService,
    private cdr: ChangeDetectorRef,
    public appComponent: AppComponent,
    private location: Location,
    private restService: RestService,
    private alertService: AlertService,
    private msalService: MsalService,
    private datePipe: DatePipe,
    private router: Router) {
    this.activatedRoute.params.subscribe(params => {
      this.refNo = params['refNo'];
      this.lastNameS = params['lastNameS'];
    });
    this.getRemoteData();
  }

  ngOnInit(): void {
    this.alertService.clear();
    //this.getRemoteData();
    this.form = new UntypedFormGroup({
      isSignedWaiverReceivedOptions: new UntypedFormControl(this.isSignedWaiverReceived),
      //buildingMakeSafeRequiredOptions: new UntypedFormControl(this.buildingMakeSafeRequired, [Validators.required]),
      buildingMakeSafeStartDate: new UntypedFormControl(null),
      buildingMakeSafeCompletedDate: new UntypedFormControl(null),

      //restorationMakeSafeRequiredOptions: new UntypedFormControl(this.restorationMakeSafeRequired, [Validators.required]),
      restorationMakeSafeStartDate: new UntypedFormControl(null),
      restorationMakeSafeCompletedDate: new UntypedFormControl(null)
    });

    //this.form.controls.isSignedWaiverReceivedOptions.markAsTouched();
    // this.form.controls.buildingMakeSafeRequiredOptions.markAsTouched();
    // this.form.controls.restorationMakeSafeRequiredOptions.markAsTouched();

    const email = this.msalService.instance.getActiveAccount()!.username!;
    this.restService.getUserDetailsByEmail(email).subscribe((x:Employee)=>{
      this.employeeId=x.employeeId; 
    });

  }

  radioChange(event: any, index:number=-1){
    this.isChanged=true;
    if (index === 1) {
      this.buildingMakeSafeRequired = event.target.type === 'checkbox' ? event.target.checked : event.target.value;//event.value;
      // this.form.controls.buildingMakeSafeRequiredOptions.setValue(this.buildingMakeSafeRequired);
      // this.form.controls.buildingMakeSafeRequiredOptions.updateValueAndValidity();
    }
    else if (index === 2){
      this.restorationMakeSafeRequired = event.target.type === 'checkbox' ? event.target.checked : event.target.value;//event.value;
      // this.form.controls.restorationMakeSafeRequiredOptions.setValue(this.restorationMakeSafeRequired);
      // this.form.controls.restorationMakeSafeRequiredOptions.updateValueAndValidity();
    }
    else{
      this.isSignedWaiverReceived =  event.target.type === 'checkbox' ? event.target.checked : event.target.value;//event.value;
      // this.form.controls.isSignedWaiverReceivedOptions.setValue(this.isSignedWaiverReceived);
      // this.form.controls.isSignedWaiverReceivedOptions.updateValueAndValidity();
    }
    this.cdr.detectChanges();
  }

  getRemoteData() {
    try {
      this.loading = true;
      this.isChanged=false;
      this.restService.getClaimDetailsForUpdate(this.refNo).subscribe((cases:ClaimDetails) => {
      if (cases){
        this.claim=cases;
        this.buildingMakeSafeRequired = this.claim.makesafeRequiredBld;
        this.restorationMakeSafeRequired = this.claim.makesafeRequiredRst;
        this.isSignedWaiverReceived = this.claim.signedWaiverReceived;

        this.form.controls.buildingMakeSafeStartDate.setValue(this.claim.makesafeRequiredBld ? this.claim.makesafeStartedDateBld : null);
        this.form.controls.buildingMakeSafeStartDate.updateValueAndValidity();
        this.form.controls.buildingMakeSafeCompletedDate.setValue(this.claim.makesafeRequiredBld ? this.claim.makesafeCompletedDateBld : null);
        this.form.controls.buildingMakeSafeCompletedDate.updateValueAndValidity();

        this.form.controls.restorationMakeSafeStartDate.setValue(this.claim.makesafeRequiredRst ? this.claim.makesafeStartedDateRst : null);
        this.form.controls.restorationMakeSafeStartDate.updateValueAndValidity();
        this.form.controls.restorationMakeSafeCompletedDate.setValue(this.claim.makesafeRequiredRst ? this.claim.makesafeCompletedDateRst : null);
        this.form.controls.restorationMakeSafeCompletedDate.updateValueAndValidity();

        this.form.controls.buildingMakeSafeStartDate.valueChanges.subscribe((newValue) => {
          this.isChanged=true;
        });
        this.form.controls.buildingMakeSafeCompletedDate.valueChanges.subscribe((newValue) => {
          this.isChanged=true;
        });
        this.form.controls.restorationMakeSafeStartDate.valueChanges.subscribe((newValue) => {
          this.isChanged=true;
        });
        this.form.controls.restorationMakeSafeCompletedDate.valueChanges.subscribe((newValue) => {
          this.isChanged=true;
        });
    
        this.loading = false;
      }
      },
      error => {
        this.loading = false;
        return false;
      }
      );
      return true;
    }
    catch (error: any) {
      this.alertService.error(error);
      return false;
    }
  }

  public onCancel = () => {
    this.location.back();
  }

public updateClaim= (formValue: any) => {
  if (this.form.valid) {
    const bldMakeSafeEstimateDelete  = (this.claim.makesafeRequiredBld && !this.buildingMakeSafeRequired && this.claim.siteReserveBldMakeSafe !== null && this.claim.siteReserveBldMakeSafe >= 0);
    const rstMakeSafeEstimateDelete = (this.claim.makesafeRequiredRst && !this.restorationMakeSafeRequired && this.claim.siteReserveRstMakeSafe !== null && this.claim.siteReserveRstMakeSafe >= 0);
    
    const isBldDatesEmpty = this.buildingMakeSafeRequired && this.form.controls.buildingMakeSafeStartDate.value === null && this.form.controls.buildingMakeSafeCompletedDate.value === null;
    const isRstDatesEmpty = this.restorationMakeSafeRequired && this.form.controls.restorationMakeSafeStartDate.value === null && this.form.controls.restorationMakeSafeCompletedDate.value === null;
    if (isBldDatesEmpty){
      Swal.fire({
      title: 'You set the Building Make Safe as Required, but you have not set Started Date and Completed Date!<br/><br/>Are you sure you want to leave the dates as empty and update later? Click Yes to continue, or click No to go back to check.',
      icon: 'question',
      showDenyButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
      confirmButtonColor: '#007bff',
      denyButtonColor: '#dc3545',
      focusDeny: true,
      width: 450,
      padding: '1em',
      heightAuto: false
      }).then((result) => {
      if (result.isConfirmed) {
        this.submitted = true;
        this.alertService.clear();
        this.updateData();
      }
      });
    }
    else if (isRstDatesEmpty){
      Swal.fire({
      title: 'You set the Restoration Make Safe as Required, but you have not set Started Date and Completed Date!<br/><br/>Are you sure you want to leave the dates as empty and update later? Click Yes to continue, or click No to go back to check.',
      icon: 'question',
      showDenyButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
      confirmButtonColor: '#007bff',
      denyButtonColor: '#dc3545',
      focusDeny: true,
      width: 450,
      padding: '1em',
      heightAuto: false
      }).then((result) => {
      if (result.isConfirmed) {
        this.submitted = true;
        this.alertService.clear();
        this.updateData();
      }
      });
    }
    else if ((this.form.controls.restorationMakeSafeRequiredOptions.value && (this.form.controls.restorationMakeSafeStartDate.value !== null && this.form.controls.restorationMakeSafeCompletedDate.value && new Date(this.form.controls.restorationMakeSafeStartDate.value)) > (new Date(this.form.controls.restorationMakeSafeCompletedDate.value)))
        || (this.form.controls.buildingMakeSafeRequiredOptions.value && (this.form.controls.buildingMakeSafeStartDate.value !== null && this.form.controls.buildingMakeSafeCompletedDate.value && new Date(this.form.controls.buildingMakeSafeStartDate.value)) > (new Date(this.form.controls.buildingMakeSafeCompletedDate.value)))) {
        Swal.fire({
          title: '<strong>Start date later than Completed date!</strong><br/><br/> The Make Safe(s) Start date later than Completed date, please check and fix before update!',
          icon: 'warning',
          showDenyButton: false,
          confirmButtonText: `OK`,
          confirmButtonColor: '#007bff',
          width: 450,
          padding: '1em',
          heightAuto: false,
        }).then((result) => {
          if (result.isConfirmed) {
            return;
          }
        });
      }
      else if (!this.buildingMakeSafeRequired && !this.restorationMakeSafeRequired && this.claim.emergencyRepairEst !== null && this.claim.emergencyRepairEst > 0) {
        Swal.fire({
          title:'<strong>Both Make Safes set as not required, but Emergency Repair has an Estimate!</strong><br/><br/>The claim has Emergency Repair Estimate of $' + this.claim.emergencyRepairEst + ', are you sure you want to delete it, and delete both Site Reserve Building and Restoration Make Safe Estimate, and delete all the Started and Completed dates if have?\n\nClick Yes to delete all, or click No to check before update!',
          icon: 'question',
          showDenyButton: true,
          confirmButtonText: `Yes`,
          denyButtonText: `No`,
          confirmButtonColor: '#007bff',
          denyButtonColor: '#dc3545',
          focusDeny: true,
          width: 450,
          padding: '1em',
          heightAuto: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.submitted = true;
            this.alertService.clear();
            this.updateData();
          }
        });
      //  Swal.fire({
    //    title: '<strong>Both Make Safes set as not required, but Emergency Repair has an Estimate!</strong><br/><br/>You cannot update both Bld and Rst Make Safes as not required since the claim has an Emergency Repair Estimate of $' + this.claim.emergencyRepairEst + ', please check and fix before update!',
    //    icon: 'warning',
    //    showDenyButton: false,
    //    confirmButtonText: `OK`,
    //    confirmButtonColor: '#007bff',
    //    width: 450,
    //    padding: '1em',
    //    heightAuto: false,
    //  }).then((result) => {
    //    if (result.isConfirmed) {
    //      return;
    //    }
    //  });
    }
    else if (bldMakeSafeEstimateDelete || rstMakeSafeEstimateDelete) {
      if (this.claim.emergencyRepairEst === null || this.claim.emergencyRepairEst === 0){
        const makeSafeEstimateStr = (bldMakeSafeEstimateDelete ? 'the existing Building Make Safe Estimate $'+ this.claim.siteReserveBldMakeSafe : '') + (rstMakeSafeEstimateDelete ? (bldMakeSafeEstimateDelete ? ', and Restorastion Make Safe Estimate $'+ this.claim.siteReserveRstMakeSafe : 'the existing Restorastion Make Safe Estimate is $'+ this.claim.siteReserveRstMakeSafe):'');  
        Swal.fire({
          title: 'You set '+(bldMakeSafeEstimateDelete ? (rstMakeSafeEstimateDelete ? 'Building and Restoration' : 'Building') : (rstMakeSafeEstimateDelete ? 'Restoration' : ''))+ ' Make Safe(s) as not required, but '+ makeSafeEstimateStr +' will be deleted! are you sure?',
          icon: 'question',
          showDenyButton: true,
          confirmButtonText: `Yes`,
          denyButtonText: `No`,
          confirmButtonColor: '#007bff',
          denyButtonColor: '#dc3545',
          focusDeny: true,
          width: 450,
          padding: '1em',
          heightAuto: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.submitted = true;
            this.alertService.clear();
            this.updateData();
          }
        });
      }
      else if (this.claim.emergencyRepairEst !==0 && this.claim.emergencyRepairEst === (Number(this.claim.siteReserveBldMakeSafe) + Number(this.claim.siteReserveRstMakeSafe))){
        Swal.fire({
          title: 'You set '+ (bldMakeSafeEstimateDelete ? 'Building' : 'Restoration') +' Make Safe as not required, but the existing Make Safe Estimate is $'+ (bldMakeSafeEstimateDelete ? this.claim.siteReserveBldMakeSafe : this.claim.siteReserveRstMakeSafe) +' will be deleted! \nAnd the current Emergency Repair Estimate will deduct this amount! \nAre you sure?',
          icon: 'question',
          showDenyButton: true,
          confirmButtonText: `Yes`,
          denyButtonText: `No`,
          confirmButtonColor: '#007bff',
          denyButtonColor: '#dc3545',
          focusDeny: true,
          width: 450,
          padding: '1em',
          heightAuto: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.submitted = true;
            this.alertService.clear();
            this.updateData();
          }
        });
      }
    }
    // else if ((!this.form.controls.restorationMakeSafeRequiredOptions.value && (this.claim.makesafeCompletedDateRst || this.claim.makesafeStartedDateRst))
    //          || (!this.form.controls.buildingMakeSafeRequiredOptions.value && (this.claim.makesafeCompletedDateBld || this.claim.makesafeStartedDateBld))){
    //   Swal.fire({
    //     title: 'You marked the Make Safe(s) as Not Required, but you have set Make Safe(s) Started Date and/or Completed Date!<br/><br/>Are you sure you want to clean up the date(s) and update the Make Safes required options? Click Yes to continue, or click No to go back to check.',
    //     icon: 'question',
    //     showDenyButton: true,
    //     confirmButtonText: `Yes`,
    //     denyButtonText: `No`,
    //     confirmButtonColor: '#007bff',
    //     denyButtonColor: '#dc3545',
    //     focusDeny: true,
    //     width: 450,
    //     padding: '1em',
    //     heightAuto: false
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       this.submitted = true;
    //       this.alertService.clear();
    //       this.updateData();
    //     }
    //   });
    // }
    else{
      Swal.fire({
        title: 'Are you sure you want to update the Make Safe options?',
        icon: 'question',
        showDenyButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `No`,
        confirmButtonColor: '#007bff',
        denyButtonColor: '#dc3545',
        focusDeny: true,
        width: 450,
        padding: '1em',
        heightAuto: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.submitted = true;
          this.alertService.clear();
          this.updateData();
        }
      });
    }
  }
}

updateData(){
  type Param = {
    op: string;
    path: string;
    value: number | boolean | string | null;
  };
  let body: Param []= [ { "op": "replace", "path": "/refNo", "value": this.refNo }];
  let noteStr:string[] = [];
  if (this.claim.signedWaiverReceived !== this.isSignedWaiverReceived){
    body.push({ "op": "replace", "path": "/signedWaiverReceived", "value": this.isSignedWaiverReceived });
    noteStr.push('The Signed Waiver Received has updated from ' + this.claim.signedWaiverReceived + ' to '+ this.isSignedWaiverReceived);
  }

  if ((this.claim.makesafeStartedDateBld === null ? null : String(this.datePipe.transform(this.claim.makesafeStartedDateBld, 'yyyy-MM-dd')).trim()) !== (this.buildingMakeSafeRequired && this.form.controls.buildingMakeSafeStartDate.value !==null ? String(this.datePipe.transform(this.form.controls.buildingMakeSafeStartDate.value, 'yyyy-MM-dd')).trim() : null)){
    body.push({ "op": "replace", "path": "/makesafeStartedDateBld", "value": this.buildingMakeSafeRequired ? this.datePipe.transform(this.form.controls.buildingMakeSafeStartDate.value, 'yyyy-MM-dd') : null });
    noteStr.push('The Building Make Safe Started Date has updated from '+ this.datePipe.transform(this.claim.makesafeStartedDateBld, 'yyyy-MM-dd') + ' to '+ (this.buildingMakeSafeRequired ? this.datePipe.transform(this.form.controls.buildingMakeSafeStartDate.value, 'yyyy-MM-dd') : 'null'));
  }
  if ((this.claim.makesafeCompletedDateBld === null ? null : String(this.datePipe.transform(this.claim.makesafeCompletedDateBld, 'yyyy-MM-dd')).trim()) !== (this.buildingMakeSafeRequired && this.form.controls.buildingMakeSafeCompletedDate.value !==null ? String(this.datePipe.transform(this.form.controls.buildingMakeSafeCompletedDate.value, 'yyyy-MM-dd')).trim() : null)){
    body.push({ "op": "replace", "path": "/makesafeCompletedDateBld", "value": this.buildingMakeSafeRequired ? this.datePipe.transform(this.form.controls.buildingMakeSafeCompletedDate.value, 'yyyy-MM-dd') : null });
    noteStr.push('The Building Make Safe Completed Date has updated from '+ this.datePipe.transform(this.claim.makesafeCompletedDateBld, 'yyyy-MM-dd') + ' to '+ (this.buildingMakeSafeRequired ? this.datePipe.transform(this.form.controls.buildingMakeSafeCompletedDate.value, 'yyyy-MM-dd') : 'null'));
  }

  if ((this.claim.makesafeStartedDateRst === null ? null : String(this.datePipe.transform(this.claim.makesafeStartedDateRst, 'yyyy-MM-dd')).trim()) !== (this.restorationMakeSafeRequired && this.form.controls.restorationMakeSafeStartDate.value !==null ? String(this.datePipe.transform(this.form.controls.restorationMakeSafeStartDate.value, 'yyyy-MM-dd')).trim() : null)){
    body.push({ "op": "replace", "path": "/makesafeStartedDateRst", "value": this.restorationMakeSafeRequired ? this.datePipe.transform(this.form.controls.restorationMakeSafeStartDate.value, 'yyyy-MM-dd') : null });
    noteStr.push('The Restoration Make Safe Started Date has updated from '+ this.datePipe.transform(this.claim.makesafeStartedDateRst, 'yyyy-MM-dd') + ' to '+ (this.restorationMakeSafeRequired ? this.datePipe.transform(this.form.controls.restorationMakeSafeStartDate.value, 'yyyy-MM-dd') : 'null'));
  }
  if ((this.claim.makesafeCompletedDateRst === null ? null : String(this.datePipe.transform(this.claim.makesafeCompletedDateRst, 'yyyy-MM-dd')).trim()) !== (this.restorationMakeSafeRequired && this.form.controls.restorationMakeSafeCompletedDate.value !==null ? String(this.datePipe.transform(this.form.controls.restorationMakeSafeCompletedDate.value, 'yyyy-MM-dd')).trim() : null)){
    body.push({ "op": "replace", "path": "/makesafeCompletedDateRst", "value": this.restorationMakeSafeRequired ? this.datePipe.transform(this.form.controls.restorationMakeSafeCompletedDate.value, 'yyyy-MM-dd') : null });
    noteStr.push('The Restoration Make Safe Completed Date has updated from '+ this.datePipe.transform(this.claim.makesafeCompletedDateRst, 'yyyy-MM-dd') + ' to '+ (this.restorationMakeSafeRequired ? this.datePipe.transform(this.form.controls.restorationMakeSafeCompletedDate.value, 'yyyy-MM-dd') : 'null'));
  }

  if (!this.buildingMakeSafeRequired && !this.restorationMakeSafeRequired && this.claim.emergencyRepairEst !==null && this.claim.emergencyRepairEst>0){
    body.push({ "op": "replace", "path": "/emergencyRepairEst", "value": 0 });
    noteStr.push('The Emergency Repair Estimate has updated from $' + this.claim.emergencyRepairEst + ' to 0');
  }
  else if (this.claim.makesafeRequiredBld !== this.buildingMakeSafeRequired){
    body.push({ "op": "replace", "path": "/makesafeRequiredBld", "value": this.buildingMakeSafeRequired });
    noteStr.push('The Building Make Safe Required has updated from ' + this.claim.makesafeRequiredBld + ' to '+ this.buildingMakeSafeRequired);
    
    if (this.claim.makesafeRequiredBld){
      if (this.claim.siteReserveBldMakeSafe !== null && this.claim.siteReserveBldMakeSafe !== 0){
        body.push({ "op": "replace", "path": "/siteReserveBldMakeSafe", "value": null });
        noteStr.push('The Site Reserve Building Make Safe Estimate has updated from $' + this.claim.siteReserveBldMakeSafe + ' to null');
      } 
  
      if (this.claim.emergencyRepairEst !==0 && this.claim.emergencyRepairEst === (Number(this.claim.siteReserveBldMakeSafe) + Number(this.claim.siteReserveRstMakeSafe))){
        body.push({ "op": "replace", "path": "/emergencyRepairEst", "value": (this.claim.makesafeRequiredRst ? this.claim.siteReserveRstMakeSafe : 0) });
        noteStr.push('The Emergency Repair Estimate has updated from $' + this.claim.emergencyRepairEst + ' to '+(this.claim.makesafeRequiredRst ? this.claim.siteReserveRstMakeSafe : 0));
      }
    }
  }
  ///////////////////////////////////////////
  else if (this.claim.makesafeRequiredRst !== this.restorationMakeSafeRequired){
    body.push({ "op": "replace", "path": "/makesafeRequiredRst", "value": this.restorationMakeSafeRequired });
    noteStr.push('The Restoration Make Safe Required has updated from ' + this.claim.makesafeRequiredRst + ' to '+ this.restorationMakeSafeRequired);
    if (this.claim.makesafeRequiredRst){
      if (this.claim.siteReserveRstMakeSafe !== null && this.claim.siteReserveRstMakeSafe !== 0){
        body.push({ "op": "replace", "path": "/siteReserveRstMakeSafe", "value": null });
        noteStr.push('The Site Reserve Restoration Make Safe Estimate has updated from $' + this.claim.siteReserveRstMakeSafe + ' to null');
      }

      if (this.claim.emergencyRepairEst !==0 && this.claim.emergencyRepairEst === (Number(this.claim.siteReserveBldMakeSafe) + Number(this.claim.siteReserveRstMakeSafe))){
        body.push({ "op": "replace", "path": "/emergencyRepairEst", "value": (this.claim.makesafeRequiredBld ? this.claim.siteReserveBldMakeSafe : 0) });
        noteStr.push('The Emergency Repair Estimate has updated from $' + this.claim.emergencyRepairEst + ' to '+(this.claim.makesafeRequiredBld ? this.claim.siteReserveBldMakeSafe : 0));
      }
    }
  }

  if (noteStr.length <=0 ){
    Swal.fire({
      title: '<strong>No any changes!</strong><br/><br/>You have not change anything, nothing to be updated, please check before click the Update button!',
      icon: 'warning',
      showDenyButton: false,
      confirmButtonText: `OK`,
      confirmButtonColor: '#007bff',
      width: 450,
      padding: '1em',
      heightAuto: false,
    }).then((result) => {
      if (result.isConfirmed) {
        return;
      }
    });
  }
  else {
    const userFullName = this.msalService.instance.getActiveAccount()!.name!;
    this.newNote = {
      refNo: this.refNo,
      date: this.datePipe.transform(new Date(), 'yyyy-MM-dd')?.toString()!,
      addedBy: userFullName,
      initiatedBy: "Mk3 Staff",
      noteTypeId: 4,
      subTypeId: 6,
      reasonId: 3,
      notes: userFullName + ' has updated the Building and Restoration Make Safes Required and Start/Completed dates option at '+ this.datePipe.transform(new Date(), 'HH:mm yyyy-MM-dd')?.toString()! + ' for -\n' + noteStr.join('. \n'),
      private: 0,//-1 = Private, 0 = Public
      timeStamp: null,
      followUpDate: null,
      followUpUser: null,
      followUpComplete: null,
      clientId: this.claim.clientId,//null,
      isExternalAssessorVisible:false,
      addedById:this.employeeId,
      claimNoteInitiatedById:1,
      isNotifyTeam:false,
    };
    
    let successMessageShown = false;
    let errorMessageShown = false;
    this.restService.updateClaimDetails(this.refNo, body)
      .pipe(
        first(),
        concatMap(() => this.restService.addNewNote(this.newNote).pipe(first())),
        // concatMap(() => from(this.generateActionsList()).pipe(
        //   concatMap((actionLogs) => from(actionLogs).pipe(
        //     concatMap((actionLog) => this.restService.addUserActionsLogDatum(actionLog))
        //   ))
        // )),
        catchError((error) => {
          if (!errorMessageShown) {
            if (error.error instanceof ErrorEvent) {
              this.errorMsg = `Error: ${error.error.message}`;
            } else {
              this.errorMsg = error;
            }
            this.alertService.clear();
            this.alertService.error(this.errorMsg);
            Swal.fire('Make Safe options updated, but failed to add new note! Please contact IT Desktop for support if you find your update not successful!', '', 'error');
            errorMessageShown = true;
          }
          return throwError(this.errorMsg);
        })
      )
      .subscribe({
        next: () => {
          if (!successMessageShown) {
            Swal.fire('Make Safe options updated successfully, and new note has been added successfully!', '', 'success');
            successMessageShown = true;
            this.router.navigate(['../case-details/' + this.claim.refNo]).then(() => {});
          }
        }
      });
    }
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.form.controls[controlName].hasError(errorName);
  }
}
   // if (isBldDatesEmpty || isRstDatesEmpty){
    //   Swal.fire({
    //   title: 'You set the '+ (isBldDatesEmpty ? (isRstDatesEmpty ? 'Building and Restoration' : 'Building') : 'Restoration')+ ' Make Safe(s) as Required, but you have not set Started Date and Completed Date!<br/><br/>Are you sure you want to leave the dates as empty and update later? Click Yes to continue, or click No to go back to check.',
    //   icon: 'question',
    //   showDenyButton: true,
    //   confirmButtonText: `Yes`,
    //   denyButtonText: `No`,
    //   confirmButtonColor: '#007bff',
    //   denyButtonColor: '#dc3545',
    //   focusDeny: true,
    //   width: 450,
    //   padding: '1em',
    //   heightAuto: false
    //   }).then((result) => {
    //   if (result.isConfirmed) {
    //     this.submitted = true;
    //     this.alertService.clear();
    //     this.updateData();
    //   }
    //   });
    // }